import classNames from 'classnames';
import { FunctionComponent, ReactNode } from 'react';
import styles from './styles.module.css';

export type DeliveryOptionProps = {
    icon: ReactNode;
    label: string;
    checked: boolean;
    focussed?: boolean;
    children?: ReactNode | Array<ReactNode>;
};

export const DeliveryOption: FunctionComponent<DeliveryOptionProps> = ({
    icon,
    label,
    checked,
    focussed = false,
    children,
}) => {
    return (
        <div
            className={classNames(styles.container, {
                [styles.checked]: checked,
                [styles.focussed]: focussed,
            })}
        >
            <div className={styles.optionData}>
                <input type="radio" checked={checked} />
                <span aria-hidden={true}>{icon}</span>
                <span className={styles.label}>{label}</span>
            </div>
            {children && checked ? (
                <div className={styles.optionConfig}>
                    <hr />
                    {children}
                </div>
            ) : null}
        </div>
    );
};
